import { gql } from '@apollo/client';

export interface CreditCounterpartSummaryProps {
  __typename?: 'CounterpartSummary';
  counterpartName: string;
  rating?: string;
  negotiationDeadlineLabel?: string;
  exposureMtmFiltered: number;
  financialBalance: number;
}

export interface PayloadProps {
  accountId: string;
}

export interface ResponseProps {
  creditCounterpartSummary?: CreditCounterpartSummaryProps;
}

const CREDIT_COUNTERPART_SUMMARY = gql`
  query creditCounterpartSummary($accountId: ID!) {
    creditCounterpartSummary(accountId: $accountId) {
      counterpartName
      rating
      negotiationDeadlineLabel
      exposureMtmFiltered
      financialBalance
    }
  }
`;

export default CREDIT_COUNTERPART_SUMMARY;
